import { List, Map, Record } from 'immutable'
import _ from 'lodash'

export function createLoadModuleAccessRightAction(type) {
    return {
        type: `LOAD_${_.toUpper(type)}_MODULE_ACCESS_RIGHTS`,
    }
}

// REPORT RECORDS

export const ReportBlockAccessRightRecord = Record({
    name: '',
    defaultLevel: 0,
    isDisabled: false,
    order: 0,
    availableLevels: List(),
    parameters: Map(),
    flags: Map(),
})

export const ReportTypeAccessRightRecord = Record({
    name: '',
    isDisabled: false,
    isAllowed: false,
    order: 0,
    blocks: Map(), // Map of ReportBlockAccessRightRecord
    parameters: Map(),
})

// PORTFOLIO RECORDS

export const PortfolioBlockAccessRightRecord = Record({
    name: '',
    defaultLevel: 0,
    isDisabled: false,
    order: 0,
    availableLevels: List(),
    parameters: Map(),
})

export const PortfolioTypeAccessRightRecord = Record({
    name: '',
    isDisabled: false,
    isAllowed: false,
    order: 0,
    blocks: Map(), // Map of PortfolioBlockAccessRightRecord
    parameters: Map(),
})

const transformAvailableLevels = (availableLevels = []) =>
    _.map(availableLevels, (level, index) => availableLevels.slice(0, index + 1).join())

const transformDefaultLevel = (defaultLevel, availableLevels = []) => {
    const transformedAvailableLevels = transformAvailableLevels(availableLevels)
    const defaultLevelIndex = availableLevels.indexOf(defaultLevel)

    if (defaultLevel >= 0) return transformedAvailableLevels[defaultLevelIndex]

    return defaultLevel
}

export function transformReportAccessRightsData(accessRightsTypes) {
    const reports = Map(
        _.mapValues(accessRightsTypes, (report) => {
            const blocksRight = Map(
                _.reduce(
                    report.blocks,
                    (acc, block) => ({
                        ...acc,
                        [block.name]: new ReportBlockAccessRightRecord({
                            ...block,
                            availableLevels: List(transformAvailableLevels(block.availableLevels)),
                            defaultLevel: transformDefaultLevel(block.defaultLevel, block.availableLevels),
                            parameters: Map({ ...block.parameters }),
                            flags: Map({ ...block.flags }),
                        }),
                    }),
                    {}
                )
            )

            return new ReportTypeAccessRightRecord({
                ...report,
                blocks: blocksRight,
                parameters: Map(report.parameters),
            })
        })
    )

    return Map({ reports })
}

export function transformPortfolioAccessRightsData(accessRightsTypes) {
    const portfolios = Map(
        _.mapValues(accessRightsTypes, (portfolio) => {
            const blocksRight = Map(
                _.reduce(
                    portfolio.blocks,
                    (acc, block) => ({
                        ...acc,
                        [block.name]: new PortfolioBlockAccessRightRecord({
                            ...block,
                            availableLevels: List(block.availableLevels),
                        }),
                    }),
                    {}
                )
            )

            return new PortfolioTypeAccessRightRecord({
                ...portfolio,
                blocks: blocksRight,
                parameters: Map(portfolio.parameters),
            })
        })
    )

    return Map({ portfolios })
}
